// extracted by mini-css-extract-plugin
module.exports = {"pages":"md-page_pages__s23Rd"};